import React, { useState } from "react";

import Sidebar from "components/Layouts/Sidebar";
import BaseHeader from "components/atoms/BaseHeader";
import Burger from "components/atoms/Burger";
import FooterMobile from "components/atoms/FooterMobile";
import { isMobile } from '../../../helpers/Mobile';

import useRequest from 'hooks/useRequest';

import SpinnerAbsa from 'components/atoms/SpinnerAbsa';

import "./styles.scss";

const MainLayout = ({ children }) => {
    const {
        loadingSpinner
    } = useRequest();
    const [open, setOpen] = useState(false);
    return <div className="desktop-main-layout-container">
        {!isMobile &&
            <Sidebar open={true} setOpen={setOpen}>
            </Sidebar>
        }
        {isMobile &&
            <Sidebar open={open} setOpen={setOpen}>
            </Sidebar>
        }
        <div className='right-layout-container'>
            {isMobile && <Burger open={open} setOpen={setOpen}></Burger>}
            <BaseHeader username={'Juan Perez'}></BaseHeader>
            <div className="right-layout-content">
                {children}
            </div>
            {isMobile &&
            <FooterMobile></FooterMobile>
            }
        </div>
        <SpinnerAbsa></SpinnerAbsa>
    </div>
}

export default MainLayout;





